import React from 'react';
import ServiceRequestToast from 'src/pages/ServiceRequest/ServiceRequestToast';
import { isRole } from 'src/helpers/permissions';
import { USER_ROLES } from 'src/common/constants';

interface ServiceRequestStatusToastProps {
  serviceRequest: any;
  handleStatusChange: (statusFormData: any, serviceRequestId: any) => void;
  user: any;
}

const ServiceRequestStatusToast = ({
  serviceRequest,
  handleStatusChange,
  user,
}: ServiceRequestStatusToastProps) => {
  const shouldShowToast: boolean = !isRole(
    [USER_ROLES.HOME_OWNER, USER_ROLES.REALTOR, USER_ROLES.OCCUPANT],
    user
  );

  if (!shouldShowToast) {
    return null;
  }

  return (
    <ServiceRequestToast
      serviceRequest={serviceRequest}
      handleStatusChange={handleStatusChange}
    />
  );
};

export default ServiceRequestStatusToast;